import { inject } from '@angular/core';
import { from, of } from 'rxjs';
import { catchError, map } from 'rxjs';
import { CanDeactivateComponent } from '../../components/can-deactivate.component';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';

/**
 * Unsaved-changes guard for the AI order parser screens.
 *
 * Same job as the platform's CanDeactivateGuard, with one deliberate difference: staying on the
 * form is the default. The modal renders `btnTrue` as the filled primary button, so "stay" is
 * passed there and the result inverted — losing typed work should take the more deliberate click,
 * not the reflexive one. Dismissing the modal (Esc, backdrop, the cross) also stays.
 */
export const aiParserUnsavedChangesGuard = (component: CanDeactivateComponent) => {
  if (component.canDeactivate()) {
    return true;
  }
  return from(
    inject(GungModalService).openConfirmYesNoModal(
      'UNSAVED_CHANGES_HEADING',
      'UNSAVED_CHANGES_CONTENT',
      undefined,
      'AI_PARSER_UNSAVED_STAY',
      'AI_PARSER_UNSAVED_LEAVE'
    )
  ).pipe(
    map(stay => !stay),
    catchError(() => of(false))
  );
};
